
import { Accordion, AccordionDetails, AccordionSummary, Grid, Tooltip } from '@mui/material';
import React from 'react';
import Consolas from '../../../fonts/Consolas';
import {
    H2,
} from '../../../helper/constants';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { SkillCardProps } from './helper';
import "./SkillsCard.css"
const SkillCard = ({ category, skillset = [] }: SkillCardProps): JSX.Element =>
(
    <Accordion>
        <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header">
            <Consolas as={H2}>{category}</Consolas>
        </AccordionSummary>
        <AccordionDetails>

            <Grid container spacing={1}>{skillset.map((e, i) =>
            (
                <Grid item key={i}>
                    <Tooltip title={e.alt}>
                        <img src={e.img} width={45} alt={e.alt} />
                    </Tooltip>

                </Grid>
            ))}
            </Grid>
        </AccordionDetails>
    </Accordion>
)
export default SkillCard;
